import { create } from 'apisauce';
import merge from 'ramda/src/merge';
import { ClientConfig } from '~client/client-config';
import { BaseController } from '~client/controller/base-controller';
import { DEFAULT_CONFIG } from '~client/default-config';

/**
 * This client is a simple client with a single controller.
 */
export class SimpleClient extends BaseController {
  constructor(config: ClientConfig) {
    const combinedConfig = merge(DEFAULT_CONFIG, config);
    const api = create(combinedConfig);

    super(api, combinedConfig);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/simple-client.ts